import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const GalleryChevronLeftIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props} aria-hidden="true">
            <path
                d="M10 4L6 8L10 12"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

GalleryChevronLeftIcon.propTypes = {onClick: PropTypes.func}

export default GalleryChevronLeftIcon
